import {
  FacebookLogoIcon,
  GlobeIcon,
  GoogleLogoIcon,
  type Icon,
  InstagramLogoIcon,
  LinkedinLogoIcon,
  TiktokLogoIcon,
  YoutubeLogoIcon,
} from '@phosphor-icons/react';
import { PLATFORM_LABELS, type Platform } from '@regia/shared';

export const PLATFORM_ICONS: Record<Platform, Icon> = {
  facebook: FacebookLogoIcon,
  instagram: InstagramLogoIcon,
  google_business: GoogleLogoIcon,
  website: GlobeIcon,
  tiktok: TiktokLogoIcon,
  youtube: YoutubeLogoIcon,
  linkedin: LinkedinLogoIcon,
};

export function PlatformIcon({
  platform,
  size = 18,
  className,
}: {
  platform: Platform;
  size?: number;
  className?: string;
}) {
  const IconCmp = PLATFORM_ICONS[platform];
  return <IconCmp size={size} className={className} aria-label={PLATFORM_LABELS[platform]} />;
}

export { PLATFORM_LABELS };
